import React from "react";
import { Box, Typography, Container } from "@mui/material";

const WhatIBelieve = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#0A192F", // Consistent Deep Navy
        color: "#FFF",
        py: 12,
        px: 2,
      }}
    >
      <Container maxWidth="md">
        {/* Section Heading Label */}
        <Typography
          sx={{
            color: "#C59324",
            fontWeight: 700,
            letterSpacing: "0.2em",
            fontSize: "0.85rem",
            textTransform: "uppercase",
            mb: 2,
            textAlign: "start",
          }}
        >
          My Values
        </Typography>

        {/* Main Section Heading */}
        <Typography
          sx={{
            fontFamily: "'Playfair Display', serif",
            color: "#fff",
            fontWeight: 600,
            lineHeight: 1.1,
            mb: 6,
            fontSize: { xs: "2.5rem", md: "3.5rem" },
            textAlign: "start",
          }}
        >
          What I{" "}
          <Box
            component="span"
            sx={{
              color: "#C59324",
              fontStyle: "italic",
              fontWeight: 500,
            }}
          >
            Believe
          </Box>
        </Typography>

        {/* Content Body */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            textAlign: "start",
          }}
        >
          <Typography
            sx={{
              color: "#B8C0D1",
              fontSize: "1.1rem",
              lineHeight: 1.8,
            }}
          >
            I don't agree with party labels and feel every candidate should run
            on the issues, not the label. Every voter should base their vote on
            how the candidate aligns with them, not the label.
          </Typography>

          <Typography
            sx={{
              color: "#B8C0D1",
              fontSize: "1.1rem",
              lineHeight: 1.8,
            }}
          >
            Yes, I am a Republican. I am a Republican because I believe in less
            government, not more. I believe in the Constitution. I believe the
            government should live within its means, and not the "tax and spend"
            mentality we currently have. I believe we need to support those on
            the front line: police, fire fighters, EMS, and teachers. We need to
            support our veterans. We need to support our senior citizens, people
            with disabilities, and those on fixed incomes. We need to protect
            our small businesses and cut the red tape, wherever safety and
            quality is not impacted, to help them grow. We need to demand
            accountability from our school leaders, from our utilities, and most
            importantly, from our elected officials. I believe we need
            transparency at every level where our tax dollars are spent. I
            believe if the democrats obtain the supermajority in the House of
            Representatives, to go along with their supermajority in the Senate,
            along with the Governor's position, we will lose what little voice
            we have left in government. Decisions will be made with little to no
            meaningful input, and our Delaware Constitution will be amended in
            ways that will attack our very freedoms in which our State has
            previously been protected.
          </Typography>

          <Typography
            sx={{
              color: "#B8C0D1",
              fontSize: "1.1rem",
              lineHeight: 1.8,
            }}
          >
            I believe government has forgotten who their employer actually is:{" "}
            <Box component="span" sx={{ fontWeight: "bold", color: "#FFF" }}>
              WE THE PEOPLE
            </Box>
            . I believe it is time we remind them, and stop letting the tail wag
            the dog.
          </Typography>

          <Typography
            sx={{
              color: "#B8C0D1",
              fontSize: "1.1rem",
              lineHeight: 1.8,
            }}
          >
            My role as your representative is to focus on{" "}
            <Box component="span" sx={{ fontWeight: "bold", color: "#FFF" }}>
              MIDDLETOWN issues
            </Box>
            , not National ones. If{" "}
            <Box component="span" sx={{ fontWeight: "bold", color: "#FFF" }}>
              YOU
            </Box>{" "}
            hold similar beliefs then I hope to have your support and your vote.
          </Typography>

          <Typography
            sx={{
              pt: 2,
              fontStyle: "italic",
              color: "#B8C0D1",
              fontSize: "1.1rem",
              lineHeight: 1.8,
            }}
          >
            The only test I will have as your representative is, "Does this make
            sense for us in Middletown?" That is the only test that matters to
            me, not labels.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default WhatIBelieve;
